import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const handleNav = (href: string) => {
    if (href === '#') return;
    if (location.pathname === '/') {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 380);
    }
  };

  const socialLinks = [
    { icon: 'ri-weibo-line', href: '#', external: false, qrCode: null, label: '', tooltip: '@NIMO智能眼镜' },
    { icon: 'ri-wechat-line', href: '#', external: false, qrCode: 'https://storage.readdy-site.link/project_files/09ac3b88-05d8-4a69-af11-22c685bd56bb/34fbda00-5f69-45a8-9817-dfa70c0a79fd_qrcode_for_gh_65b1ae0ae236_258.jpg?v=06624706da3ea799515b521ee910f599', label: '扫码关注公众号', tooltip: null },
    { icon: 'ri-tiktok-line', href: 'https://www.douyin.com/user/MS4wLjABAAAAZSimFDPLHv_Ns3F_B1XOKwvMfhIcQ5Hpi-tlIThP7r09C5l4vxAxrQ016gpcD5B5?from_tab_name=main', external: true, qrCode: 'https://static.readdy.ai/image/7c44e70ab9ad63a75c237184bae01347/cd369541d7668e8c796696fbcaaf20a8.png', label: '扫码关注抖音号', tooltip: null },
    { icon: 'ri-bilibili-line', href: '#', external: false, qrCode: 'https://storage.readdy-site.link/project_files/09ac3b88-05d8-4a69-af11-22c685bd56bb/5793e7fc-3ef2-487b-8145-d7135d2dddd0_eea2f54a4d4f04af6caf7a553143a28.jpg?v=92bf536badeba5b66ea18a2563325bd3', label: '扫码关注B站', tooltip: null },
  ];

  return (
    <footer className="w-full bg-[#F5EEE4] pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row gap-16 mb-16">
          <div className="lg:w-2/5 flex-shrink-0">
            <img src="https://storage.readdy-site.link/project_files/09ac3b88-05d8-4a69-af11-22c685bd56bb/4837eb5d-9b46-4854-a281-dde8722f2153__20250913141658.png?v=65325fb37797eb4325c86ce1fe315465" alt="NIMO AI Logo" className="h-8 w-auto object-contain mb-6" loading="lazy" decoding="async" />
            <p className="font-zh-serif text-stone-600 text-lg font-light mb-3">{t('footer_tagline')}</p>
            <p className="font-noto text-stone-400 text-sm font-light leading-6 mb-4 max-w-xs">{t('footer_desc')}</p>
            <div className="flex gap-4">
              {socialLinks.map(({ icon, href, external, qrCode, label, tooltip }) => (
                <div key={icon} className="relative group">
                  <a href={href} {...(external ? { target: '_blank', rel: 'nofollow noopener noreferrer' } : {})} onClick={!external ? (e) => { e.preventDefault(); } : undefined} className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-300 text-stone-500 hover:border-stone-700 hover:text-stone-800 transition-all cursor-pointer">
                    <i className={`${icon} text-base`} />
                  </a>
                  {tooltip && !qrCode && (
                    <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-3 opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-200 scale-95 group-hover:scale-100 origin-bottom z-50">
                      <div className="bg-white rounded-xl px-3 py-2 whitespace-nowrap" style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.10)' }}><p className="text-stone-700 text-xs font-medium">{tooltip}</p></div>
                      <div className="flex justify-center"><div className="w-2.5 h-2.5 bg-white rotate-45 -mt-1.5" style={{ boxShadow: '2px 2px 4px rgba(0,0,0,0.06)' }} /></div>
                    </div>
                  )}
                  {qrCode && (
                    <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-3 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-all duration-200 scale-95 group-hover:scale-100 origin-bottom z-50">
                      <div className="bg-white rounded-2xl p-3 w-44" style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.10)' }}>
                        <div className="w-full h-44 overflow-hidden rounded-xl mb-2"><img src={qrCode} alt={label} className="w-full h-full object-cover object-top" /></div>
                        <p className="text-center text-stone-500 text-xs leading-4">{label}</p>
                        <p className="text-center text-stone-400 text-xs mt-0.5">NIMO智能眼镜</p>
                      </div>
                      <div className="flex justify-center"><div className="w-2.5 h-2.5 bg-white rotate-45 -mt-1.5" style={{ boxShadow: '2px 2px 4px rgba(0,0,0,0.06)' }} /></div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-10">
            <div>
              <h4 className="font-label text-stone-800 text-xs tracking-[0.3em] uppercase mb-6">{t('footer_nav')}</h4>
              <ul className="flex flex-col gap-3">
                <li><a href="#home" onClick={(e) => { e.preventDefault(); handleNav('#home'); }} className="text-stone-500 text-sm font-light hover:text-stone-800 transition-colors cursor-pointer">{t('footer_nav_home')}</a></li>
                <li><a href="#brand" onClick={(e) => { e.preventDefault(); handleNav('#brand'); }} className="text-stone-500 text-sm font-light hover:text-stone-800 transition-colors cursor-pointer">{t('footer_nav_brand')}</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-label text-stone-800 text-xs tracking-[0.3em] uppercase mb-6">{t('footer_products')}</h4>
              <ul className="flex flex-col gap-3">
                <li><a href="/NIMO" onClick={(e) => { e.preventDefault(); navigate('/NIMO'); }} className="text-stone-500 text-sm font-light hover:text-stone-800 transition-colors cursor-pointer">{t('footer_product_nimo')}</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-label text-stone-800 text-xs tracking-[0.3em] uppercase mb-6">{t('footer_biz')}</h4>
              <div className="w-24 h-24 rounded-lg overflow-hidden border border-stone-200 mb-2">
                <img src="https://static.readdy.ai/image/7c44e70ab9ad63a75c237184bae01347/4f79ac6526da52b3b0655c6aa0854161.png" alt="商务合作微信二维码" className="w-full h-full object-cover object-top" loading="lazy" decoding="async" />
              </div>
              <p className="text-stone-400 text-xs leading-5">{t('footer_biz_label')}</p>
            </div>
            <div>
              <h4 className="font-label text-stone-800 text-xs tracking-[0.3em] uppercase mb-6">{t('footer_contact')}</h4>
              <ul className="flex flex-col gap-3">
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"><i className="ri-mail-line text-stone-400 text-sm" /></div>
                  <a href="mailto:nimo@nimofantasy.ai" className="text-stone-500 text-sm font-light hover:text-stone-800 transition-colors cursor-pointer whitespace-nowrap">nimo@nimofantasy.ai</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-4 border-t border-stone-200">
          <div className="flex flex-col md:flex-row items-center justify-between gap-1.5">
            <p className="text-stone-400 text-xs font-light">{t('footer_copyright')}</p>
            <div className="flex items-center gap-4">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener noreferrer" className="text-stone-400 text-xs font-light hover:text-stone-600 transition-colors cursor-pointer">{t('footer_icp')}</a>
              <span className="text-stone-300 text-xs">·</span>
              <a href="/agreement" onClick={(e) => { e.preventDefault(); navigate('/agreement'); }} className="text-stone-400 text-xs font-light hover:text-stone-600 transition-colors cursor-pointer">{t('footer_agreement')}</a>
              <span className="text-stone-300 text-xs">·</span>
              <a href="https://bitfantasy.com.cn/privacy.html" target="_blank" rel="nofollow noopener noreferrer" className="text-stone-400 text-xs font-light hover:text-stone-600 transition-colors cursor-pointer">{t('footer_privacy')}</a>
            </div>
          </div>
          <p className="text-stone-400 text-xs font-light leading-relaxed mt-2 text-left">{t('footer_ad_notice')}</p>
        </div>
      </div>
    </footer>
  );
}
